import { SET_SELECT_ACCOUNT } from '../action/types';

const ReplenishAccount = (state = [], action) => {
    switch (action.type) {
        case SET_SELECT_ACCOUNT:
            return {
                ...state,
                selectedAccount:action.payload
            };
        default: {
            return { ...state };
        }
    }
};

export default ReplenishAccount;